export const KEY = 'lib_digital_file'
